import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * `/projetos/novo` e `/projetos/:id/editar` → o mesmo formulário sob
 * `/calendario`, preservando `?data=` e `?ministerio=`.
 *
 * **Por que o formulário mudou de endereço.** Os dois botões que o abrem —
 * "Novo projeto" na barra da grade e "Ajustar" na caixa de entrada — vivem no
 * Calendário, e mandavam para uma rota de `/projetos`. Para `leader` e
 * `assistant` isso é um endereço cuja aba não está no menu (decisão 97,
 * [ADR-015](../../docs/adr/ADR-015-agenda-volatil.md) §6): a trilha oferecia
 * "voltar" para uma listagem que, para eles, não é ponto de partida nenhum. O
 * `fallbackFor` do Calendário salvava a marca da sidebar, mas não o resto —
 * ele conserta qual aba acende, não para onde o "voltar" aponta.
 *
 * A correção não é adotar melhor: é **mudar de dono**. O formulário é o verbo
 * do Calendário para os cinco papéis, e não um pedaço do acervo; `/projetos`
 * segue sendo a listagem que atravessa meses, e ela não abre nem cria nada.
 *
 * ⚠️ **`:id` aqui é id de PROJETO, não de calendário** — `/calendario/:id`
 * (folha do projeto) continua não existindo, e a ausência continua sendo a
 * decisão (1ª rodada da análise, decisão 1): duas telas do mesmo projeto
 * divergem em meses. Quem clica num item da grade vai para `/projetos/:id`.
 *
 * `replace`: o endereço antigo não pode ficar no histórico, senão o botão
 * voltar do navegador devolveria a pessoa ao redirect e ela quicaria de volta.
 */
export function LegacyFormRedirect() {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  return <Navigate to={`/calendario/${id ? `${id}/editar` : 'novo'}${search}`} replace />;
}
